import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';

interface StepperIconRootProps {
  active?: boolean;
  completed?: boolean;
  disabled?: boolean;
  in_progress?: boolean;
}

const Root = styled('div', {
  shouldForwardProp: (prop: PropertyKey) =>
    !(['active', 'completed', 'disabled', 'in_progress'] as string[]).includes(prop as string),
})<StepperIconRootProps>(({ theme, active, completed, disabled, in_progress }) => ({
  height: 24,
  width: 24,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  border: '1px solid',
  transition: 'all 0.2s ease',
  borderColor: disabled
    ? theme.palette.grey[300]
    : active || completed || in_progress
      ? theme.palette.primary.light
      : theme.palette.grey[300],
  backgroundColor: active || completed || in_progress ? theme.palette.primary.light : 'transparent',
  '& .stepper-icon': { color: theme.palette.primary.contrastText },
}));

interface StepperIconProps {
  active?: boolean;
  completed?: boolean;
  in_progress?: boolean;
  className?: string;
  disabled?: boolean;
}

export default function StepperIcon({ active, completed, in_progress, className, disabled }: StepperIconProps) {
  return (
    <Root active={active} completed={completed} disabled={disabled} in_progress={in_progress} className={className}>
      {completed && <Icon icon='material-symbols:check' className='stepper-icon' width={18} />}
    </Root>
  );
}
